import Vue from 'vue';
import { formatCurrency } from '@/helpers/NumberFormatter';

Vue.filter('moneyFormat', (rawPrice: number | null | undefined) => {
    return formatCurrency(rawPrice, 2, 2);
});
